import React from 'react';
import { Marker, MarkerProps } from 'react-leaflet';
import L from 'leaflet';

import { cn } from '@/lib/utils';

const busSvg = `<svg xmlns="http://www.w3.org/2000/svg" class="bus-marker" width="60" height="80" viewBox="0 0 60 80" fill="none">
  <!-- Drop shadow -->
  <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
    <feDropShadow dx="0" dy="3" stdDeviation="4" flood-color="currentColor" flood-opacity="0.25"/>
  </filter>

  <!-- Pin shape with gradient -->
  <path d="M30 0C16 0 4 12 4 26C4 43 30 80 30 80C30 80 56 43 56 26C56 12 44 0 30 0Z"
        fill="url(#grad)" filter="url(#shadow)"/>

  <!-- Gradient definition using currentColor with opacity stops -->
  <defs>
    <linearGradient id="grad" x1="30" y1="0" x2="30" y2="80" gradientUnits="userSpaceOnUse">
      <stop offset="0%" stop-color="currentColor" stop-opacity="1"/>
      <stop offset="100%" stop-color="currentColor" stop-opacity="0.75"/>
    </linearGradient>
  </defs>

  <!-- White circle background for the bus icon -->
  <circle cx="30" cy="26" r="16" fill="white"/>

  <!-- Bus icon centered -->
  <g transform="translate(18, 14)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <path d="M4 6 2 7"/>
      <path d="M10 6h4"/>
      <path d="m22 7-2-1"/>
      <rect width="16" height="16" x="4" y="3" rx="2"/>
      <path d="M4 11h16"/>
      <path d="M8 15h.01"/>
      <path d="M16 15h.01"/>
      <path d="M6 19v2"/>
      <path d="M18 21v-2"/>
    </svg>
  </g>

  <!-- Motion lines to show movement -->
  <path d="M10 55 C20 50, 40 50, 50 55" stroke="white" stroke-width="2" stroke-linecap="round" stroke-dasharray="4 3" opacity="0.6"/>
</svg>
`;

const BusMarker = React.forwardRef<
  L.Marker<any>,
  Omit<MarkerProps, 'icon'> & { className?: string }
>(({ className, ...props }, ref) => (
  <Marker
    ref={ref}
    draggable={false}
    {...props}
    icon={L.divIcon({
      iconAnchor: [64 / 2, 64],
      iconSize: [64, 64],
      html: busSvg,
      className: cn('text-primary', className),
    })}
  />
));

export default BusMarker;
